import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../ModuleSubtopic";

const ALL_CALCULUS_SUBTOPICS = [
    { name: 'Limit and continuity for two variables', path: '/cal-m2-s1' },
    { name: 'Partial derivative', path: '/cal-m2-s2' },
    { name: 'Jacobian', path: '/cal-m2-s3' },
    { name: 'Taylor\'s series', path: '/cal-m3-s1' },
    { name: 'Min and Max in two variables', path: '/cal-m3-s2' },
    { name: 'Lagrange\'s method of undetermined', path: '/cal-m3-s3' },
    { name: 'Evaluation of double integral', path: '/cal-m4-s1' },
    { name: 'Change of order', path: '/cal-m4-s2' },
    { name: 'Change of variable', path: '/cal-m4-s3' },
    { name: 'Evaluation of triple integration', path: '/cal-m4-s4' },
    { name: 'Using cylinder', path: '/cal-m4-s5' },
    { name: 'Using spherical', path: '/cal-m4-s6' },
    { name: 'Directional derivative', path: '/cal-m6-s1' },
    { name: 'Angle between two surfaces', path: '/cal-m6-s2' },
    { name: 'Divergence and curl', path: '/cal-m6-s3' },
    { name: 'Vector differentiation', path: '/cal-m6-s4' },
    { name: 'Line integral', path: '/cal-m7-s1' },
    { name: 'Green\'s theorem', path: '/cal-m7-s2' },
    { name: 'Surface integral', path: '/cal-m7-s3' },
    { name: 'Stokes\' theorem', path: '/cal-m7-s4' },
    { name: 'Gauss divergence theorem', path: '/cal-m7-s5' },
    { name: 'Order and Degree', path: '/de-m1-s1' },
    { name: 'Method of undetermined coefficients', path: '/de-m1-s2' },
    { name: 'Method of variation of parameters', path: '/de-m1-s3' },
    { name: 'Homogenous equation of Cauchy Euler\'s type', path: '/de-m1-s4' },
    { name: 'Solving DE in Mechanical & Electrical Circuits', path: '/de-m1-s5' },
    { name: 'Formation of pde', path: '/de-m2-s1' },
    { name: 'Solving linear pde', path: '/de-m2-s2' },
    { name: 'Solving non-linear pde', path: '/de-m2-s3' },
    { name: 'Method of separation of variables', path: '/de-m2-s4' }
];

const CalculusModuleSubtopic = ({ title, videos, takeaways, questions, exampleVideos }) => {
    const location = useLocation();
    const { subtopics = ALL_CALCULUS_SUBTOPICS, subjectPath = '/subject-CalculusModules' } = location.state || {};

    return (
        <ModuleSubtopic
            title={title}
            videos={videos}
            takeaways={takeaways}
            questions={questions}
            exampleVideos={exampleVideos}
            subtopics={subtopics || ALL_CALCULUS_SUBTOPICS}
            subjectPath={subjectPath}
        />
    );
};

export default CalculusModuleSubtopic;
